import type { RouteLocationNormalizedGeneric } from '#vue-router'
import { getCheckFile } from '~/repositories/checkFileRepository'
import { existsDailyWorkFile } from '~/repositories/dailyWorkFileRepository'

export default async (to: RouteLocationNormalizedGeneric) => {
  const { organizationId, locationId, checkFileId } = to.params
  const [exists, checkFile] = await Promise.all([
    existsDailyWorkFile(Number(checkFileId)),
    getCheckFile(Number(checkFileId)),
  ])
  // 作業記録が存在しない or 定期チェックファイルの場合は作業記録一覧へ遷移
  if (!exists || checkFile?.type === 'SCHEDULED') {
    return await navigateTo({
      name: 'organizationId-locations-locationId-monthlyWorkFiles',
      params: { organizationId, locationId },
    })
  }
}
